/* eslint-disable no-console */
interface ScrollElementIntoViewParams {
    container: HTMLElement | null;
    rect: ClientRect;
    topOffset?: number;
    bottomOffset?: number;
    keyboardHeight?: number;
}

export const getContentNode = (node: Element | null, keyboardHeight: number): HTMLElement | null => {
    if (node == null) {
        return null;
    }

    if (node.clientHeight > window.innerHeight - keyboardHeight && getComputedStyle(node).overflowY === "scroll") {
        return node as HTMLElement;
    }

    return getContentNode(node.parentElement, keyboardHeight);
};

export const getDataKeyboardScrollNode = (node: Element | null): HTMLElement | null => {
    if (node == null) {
        return null;
    }

    if (node.getAttribute("data-keyboard-scroll")) {
        return node as HTMLElement;
    }

    return getDataKeyboardScrollNode(node.parentElement);
};

export const adjustContentIntoView = (contentNode: HTMLElement | null, keyboardHeight: number): void => {
    // screen height
    const scrollHeight = contentNode?.scrollHeight;
    const contentHeight = contentNode?.clientHeight;

    if (!scrollHeight || !contentHeight) {
        return;
    }

    const viewHeightAvailable = contentHeight - keyboardHeight;
    contentNode?.style.setProperty("max-height", `${viewHeightAvailable}px`);
};

export const restoreContentIntoView = (contentNode: HTMLElement | null): void => {
    contentNode?.style.removeProperty("max-height");
};

/**
 *
 * @param container - The scrollable container
 * @param verticalScrollValue - vertical scroll value of container
 */
export const scrollContainerVertically = (container: HTMLElement, verticalScrollValue?: number): void => {
    const y = verticalScrollValue || 0;

    if (container.scroll !== undefined) {
        container.scroll(0, Math.max(y, 0));
    } else {
        container.scrollTop = Math.max(y, 0);
    }
};

/**
 *
 * @param ScrollElementIntoViewParams
 */
export const scrollElementIntoViewOnKeyboardVisible = ({
    container,
    rect,
    bottomOffset = 16,
}: ScrollElementIntoViewParams): void => {
    let y: number | undefined;

    if (!container) {
        return;
    }

    const containerRect = container.getBoundingClientRect();
    const scrollTop = container.scrollTop;

    const rectBottom = rect.bottom;
    const containerRectBottom = containerRect.bottom - bottomOffset;
    if (rectBottom < containerRectBottom) {
        y = scrollTop - (containerRectBottom - rectBottom);
    } else {
        y = scrollTop + (rectBottom - containerRectBottom);
    }

    if (y === undefined) {
        return;
    }

    container.style.setProperty("-webkit-overflow-scrolling", "auto");
    scrollContainerVertically(container, y);
    container.style.setProperty("-webkit-overflow-scrolling", "touch");
};
